<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
    id="sideNav"
  >
    <a class="navbar-brand js-scroll-trigger" href="#page-top" v-smooth-scroll>
      <span class="d-block d-lg-none"
        >{{ profile.firstName }} {{ profile.lastName }}</span
      >
      <span class="d-none d-lg-block"
        ><img
          class="img-fluid img-profile rounded-circle mx-auto mb-2"
          src="../template/assets/img/profile.jpg"
          alt=""
      /></span>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#about" v-smooth-scroll
            >About</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link js-scroll-trigger"
            href="#experience"
            v-smooth-scroll
            >Experience</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link js-scroll-trigger"
            href="#education"
            v-smooth-scroll
            >Education</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#skills" v-smooth-scroll
            >Skills</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link js-scroll-trigger"
            href="#interests"
            v-smooth-scroll
            >Interests</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link js-scroll-trigger"
            href="#portfolio"
            v-smooth-scroll
            >Portfolio</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#awards" v-smooth-scroll
            >Awards</a
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["profile"]),
};
</script>
